// extracted by mini-css-extract-plugin
export default {"AppAutocomplete":"AppAutocomplete_AppAutocomplete__G6HeK","autocomplete":"AppAutocomplete_autocomplete__y9R+c","input":"AppAutocomplete_input__YDzCv"};